var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('scene'+_vm.$store.getters.scene,{tag:"component",attrs:{"sounds":_vm.sounds,"role":"subScreen"}}),(!_vm.soundsLoaded)?_c('button',{on:{"click":_vm.loadSounds}},[_vm._v("Load sounds")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }